import type { RecoveryVerdict } from "@msuite/ui/video-recorder";

/**
 * What a stored recording's destination is worth, read off the server's answer about its row.
 *
 * `uploading` is the only status that still wants the bytes: the row was created when recording
 * began and nothing has reached Mux since. `processing` and `ready` mean the upload finished and
 * the crash came after, so the recording on disk is a duplicate. A row that is gone or `errored`
 * can never take it, and anything else — including a server that could not be reached at all —
 * is deliberately no answer rather than a guess.
 *
 * @param httpStatus - The response status.
 * @param status - The video row's status, when the response carried one.
 * @returns What to do about the recording waiting on disk.
 */
export function verdictForVideo(httpStatus: number, status: string | null): RecoveryVerdict {
	if (httpStatus === 404) return { kind: "unshippable" };
	if (httpStatus !== 200) return { kind: "unknown" };
	if (status === "uploading") return { kind: "sendable" };
	if (status === "processing" || status === "ready") return { kind: "arrived" };
	if (status === "errored") return { kind: "unshippable" };
	return { kind: "unknown" };
}
